import React from 'react';
import MyDocument from './PDFtemplate';

const Assetforms = () =>{
    return (
        <div>Asset Forms</div>
      )
}

export default Assetforms;